import { createRequest, RequestConfig } from "../../../core/libs/api";

const config: RequestConfig = {
  method: "post",
  url: "/ws/api/login",
};

export const signInRequest = (newDealer?: {
  login: string;
  password: string;
}) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(newDealer),
  });
